// src/modules/app-views/account/pages/Init/decorators/request.js
// *******************************************************************************
// REQUEST DECORATOR
// Transforms data before sending to the server
// *******************************************************************************

import { returnOnlyNumbers } from 'utils/helpers';
import entitiesService from 'services/entitiesService';

/**
 * Transforms form data before sending to the server
 *
 * @param {Object} ctx - Context object
 * @param {Object} ctx.data - Form data to be sent (changed fields only)
 * @param {Object} ctx.allValues - Complete form data with original values
 * @param {String} ctx.url - Request URL
 * @param {String} ctx.method - HTTP method
 * @returns {Object} Transformed data ready for backend
 */
const decorateRequest = ctx => {
  const { data, allValues } = ctx;

  if (!data) return data;

  return entitiesService.decorator(data, allValues, ctx);
};

export default decorateRequest;
